export const setSchoolData = (school) => {
  if (school) {
    localStorage.setItem('school', JSON.stringify(school));
  } else {
    localStorage.removeItem('school');
  }
};
